export var AreaY = {
  TOP: 'top',
  MIDDLE: 'middle',
  BOTTOM: 'bottom',
  NONE: 'none'
};
export var AreaX = {
  START: 'start',
  MIDDLE: 'middle',
  END: 'end',
  NONE: 'none'
};